// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from '@/store';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';

import './pollyfills';

import App from './App';
import routes from './router';
import GlobalComponents from './globalComponents';

Vue.use(VueRouter);
Vue.use(GlobalComponents);
Vue.config.productionTip = false;

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  scrollBehavior: to => ((to.hash) ? { selector: to.hash } : { x: 0, y: 0 }),
});

sync(store, router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router,
});



// WEBPACK FOOTER //
// ./src/main.js